import { useRef } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Button, Divider, Tooltip, Typography } from 'antd';
import styled from 'styled-components';
import { useProcContext } from '@/entities/proc';
import { ComponentType } from '@/shared/types';
import {
  CheckboxEditForm,
  ImageEditForm,
  InputEditForm,
  SelectEditForm,
  TextAreaEditForm,
  TextEditForm,
  VideoEditForm,
  CodeEditForm,
} from './index';

const { Title } = Typography;

type FormRefProps = {
  submit: () => void;
};

const Forms = {
  [ComponentType.Text]: TextEditForm,
  [ComponentType.Input]: InputEditForm,
  [ComponentType.TextArea]: TextAreaEditForm,
  [ComponentType.Image]: ImageEditForm,
  [ComponentType.Checkbox]: CheckboxEditForm,
  [ComponentType.Video]: VideoEditForm,
  [ComponentType.Select]: SelectEditForm,
  [ComponentType.Embedding]: CodeEditForm,
};

export const EditComponentView = () => {
  const { selectedComponent, setSelectedComponent, editFormLoading } =
    useProcContext();
  const formRef = useRef<FormRefProps & { isLoading?: boolean }>(null);

  const EditForm = Forms[selectedComponent.component as keyof typeof Forms];

  return (
    <div data-testid="edit-component-view">
      <SidebarHeader>
        <Tooltip title="Close">
          <Button
            type="text"
            icon={<CloseOutlined />}
            shape="circle"
            onClick={() => setSelectedComponent(undefined)}
            style={{ fontSize: 12, marginLeft: -10 }}
          />
        </Tooltip>
        <Button
          type="primary"
          size="small"
          style={{ fontSize: 13, paddingInline: 12 }}
          loading={editFormLoading}
          onClick={() => formRef.current?.submit()}
        >
          Save changes
        </Button>
      </SidebarHeader>
      <Divider style={{ margin: '0 0 20px' }} />
      <MainContent>
        <Title
          level={4}
          style={{ textAlign: 'center', width: '100%', marginBottom: 20 }}
        >{`Edit ${selectedComponent.componentName}`}</Title>
        <EditForm ref={formRef} />
      </MainContent>
    </div>
  );
};

const SidebarHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 20px;
`;

const MainContent = styled.div`
  width: 100%;
  padding-inline: 20px;
  overflow-y: auto;
`;
